export default "__VITE_ASSET__BAToKM1V__"